module.exports = __webpack_public_path__ + "img/image9.18bd7d4d.svg";